import { Routes, Route } from "react-router-dom";
import Layout from "./Components/Layout";
import Login from "./Components/Login";
import Accueil from "./Components/Accueil";
import "./App.css";
import RequireAuth from "./Components/RequireAuth";
import PersistLogin from "./Components/PersistLogin";
import ChooseLocation from "./Components/ChooseLocation";
import ChooseDuration from "./Components/ChooseDuration";
import ChooseTherapist from "./Components/ChooseTherapist";
import ChooseService from "./Components/ChooseService";
import HotelChooseService from "./Components/HotelChooseService";
import HotelChooseTherapist from "./Components/HotelChooseTherapist";
import Payment from "./Components/Payment";
import PaymentGift from "./Components/PaymentGift";
import HotelPayment from "./Components/HotelPayment";
import Confirmation from "./Components/Confirmation";
import PhoneConfirmation from "./Components/PhoneConfirmation";
import Contact from "./Components/Contact";
import VerificationNumero from "./Components/VerificationNumero";
import ValidationNumero from "./Components/ValidationNumero";
import Profile from "./Components/Profile";
import Gift from "./Components/Gift";
import Voucher from "./Components/Voucher";
import Treatment from "./Components/Treatment";
import Package from "./Components/Package";
import FavFlyPro from "./Components/FavFlyPro";
import LocationPro from "./Components/LocationPro";
import FlyProService from "./Components/FlyProService";
import FlyProBooking from "./Components/FlyProBooking";
import EditProfile from "./Components/EditProfile";
import EditAdresse from "./Components/EditAdresse";
import Register from "./Components/Register";
import ValidationPage from "./Components/ValidationPage";
import { useEffect } from "react";
import {
  generateToken,
  messaging,
  isMessagingSupported,
} from "./utils/firebase";
import useApi from "./hooks/useApi";
import { syncWebToken } from "./utils/webPushSync";
import toast, { Toaster } from "react-hot-toast";
import Commande from "./Components/Commande";
import Hotel from "./Components/Hotels";
import { onMessage } from "@firebase/messaging";
import Notification from "./Components/Notification";
import PaymentCards from "./Components/PaymentCards";
import RequireGuest from "./Components/RequireGuest";
import RequireReset from "./Components/RequireReset";
import ForgetPassword from "./Components/ForgetPassword";
import DetailsBooking from "./Components/DetailsBooking";
import useAuth from "./hooks/useAuth";
import ResetPassword from "./Components/ResetPassword";
import { initPusher, disconnectPusher } from "./services/pusher.service";
import LocaleRedirect from "./Components/LocaleRedirect";
import PaymentLinkResolver from "./Components/PaymentLinkResolver";

const ROLES = {
  Client: "ROLE_CLIENT",
  Editor: "ROLE_USER",
  Admin: "ROLE_ADMIN",
};

const processedPushEvents = new Set();

function App() {
  console.log = function () {};
  console.info = function () {};
  console.debug = function () {};
  console.warn = function () {};
  console.error = function () {};
  useEffect(() => {
    let unsubscribe;
    let disposed = false;
    const setupFirebaseMessaging = async () => {
      try {
        // Check if messaging is supported
        const isSupported = await isMessagingSupported();

        if (isSupported && messaging) {
          // Generate token only if messaging is supported
          const token = await generateToken();
          console.log("Firebase token generated:", token);

          if (disposed) return;
          unsubscribe = onMessage(messaging, (payload) => {
            console.log("Received message:", payload);
            const eventKey = payload.data?.event_key || payload.messageId;
            if (eventKey && processedPushEvents.has(eventKey)) return;
            if (eventKey) {
              processedPushEvents.add(eventKey);
              window.setTimeout(() => processedPushEvents.delete(eventKey), 60000);
            }
            if (payload.notification && payload.data) {
              toast(
                <a
                  href={payload.data.url}
                  rel="noopener noreferrer"
                  style={{
                    color: "#000000",
                    textDecoration: "underline",
                  }}
                >
                  {payload.notification.body}
                </a>
              );
            }
          });
        } else {
          console.log(
            "Firebase messaging is not supported in this browser. Notifications will not be available."
          );
        }
      } catch (error) {
        console.error("Error setting up Firebase messaging:", error);
      }
    };

    setupFirebaseMessaging();
    return () => {
      disposed = true;
      unsubscribe?.();
    };
  }, []);

  const { auth } = useAuth();
  const api = useApi();

  useEffect(() => {
    initPusher({ token: auth?.accessToken });
    return () => {
      disconnectPusher();
    };
  }, [auth?.accessToken]);

  useEffect(() => {
    if (!auth?.user?.id) return;
    syncWebToken({ userId: auth.user.id, appName: "client", axios: api }).catch(() => {});
  }, [auth?.user?.id, api]);

  return (
    <>
      {auth?.user && <Toaster position="top-right" />}

      <Routes>
        <Route path=":locale(en|fr)/*" element={<LocaleRedirect />} />
        <Route path="/payment-link/:token" element={<PaymentLinkResolver />} />
        <Route path="/" element={<Layout />}>
          <Route element={<PersistLogin />}>
            <Route element={<RequireGuest />}>
              <Route path="register" element={<Register />} />
              <Route path="login" element={<Login />} />
              <Route path="forget_password" element={<ForgetPassword />} />
              <Route path="reset-password" element={<ResetPassword />} />
            </Route>

            <Route path="contact" element={<Contact />} />
            <Route path="gifts" element={<Gift />} />
            <Route path="hotels" element={<Hotel />} />
            <Route path="validation" element={<ValidationPage />} />

            <Route path="" element={<Accueil />} />
            <Route path="choose-location" element={<ChooseLocation />} />
            <Route path="choose-duration" element={<ChooseDuration />} />
            <Route path="choose-therapist" element={<ChooseTherapist />} />
            <Route path="choose-service" element={<ChooseService />} />
            <Route path="payment" element={<Payment />} />
            <Route path="hotel-payment" element={<HotelPayment />} />
            <Route
              path="hotel-choose-service"
              element={<HotelChooseService />}
            />
            <Route
              path="hotel-choose-therapist"
              element={<HotelChooseTherapist />}
            />
            <Route path="buy-voucher" element={<Voucher />} />
            <Route path="buy-treatment" element={<Treatment />} />
            <Route path="buy-package" element={<Package />} />
            <Route path="paymentgift" element={<PaymentGift />} />
            <Route path="location-pro" element={<LocationPro />} />
            <Route path="fav-flypro" element={<FavFlyPro />} />
            <Route path="flypro-service" element={<FlyProService />} />
            <Route path="flypro-booking" element={<FlyProBooking />} />
            <Route path="confirmation" element={<Confirmation />} />

            <Route element={<RequireAuth allowedRoles={[ROLES.Client]} />}>
              <Route
                path="VerificationNumero"
                element={<VerificationNumero />}
              />
              <Route path="ValidationNumero" element={<ValidationNumero />} />
              <Route
                path="phone-confirmation"
                element={<PhoneConfirmation />}
              />
            </Route>

            <Route
              element={[
                <RequireAuth allowedRoles={[ROLES.Client]} />,
                <RequireReset />,
              ]}
            >
              <Route path="notifications" element={<Notification />} />
              <Route path="profile" element={<Profile />} />
              <Route path="my-cards" element={<PaymentCards />} />
              <Route path="commande" element={<Commande />} />
              <Route path="details" element={<DetailsBooking />} />
              <Route path="editprofile" element={<EditProfile />} />
              <Route path="editadresse" element={<EditAdresse />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
